import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Grid, TableCell } from '@mui/material';
import { useEffect, useState } from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import AdminPaginatedList from '../../components/AdminPaginatedList';
import { useBlueprintAdmin } from '../../components/AdminProvider';
import { AdminTableRow } from '../../components/AdminTable';

export const TriggerHistory = ({ id }) => {
  const [lastRun, setLastRun] = useState();
  const { config, adminTriggerApi } = useBlueprintAdmin();
  useEffect(() => {
    adminTriggerApi!
      .getRunHistory(id)
      .then(({ data }) => {
        setLastRun(data[0].createdAt);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  return (
    <>
      {lastRun} (<Moment fromNow>{lastRun}</Moment>)
    </>
  );
};

const itemTemplate = ({ status, id, name }, index) => (
  <AdminTableRow key={index}>
    <TableCell>
      <Link to={`/triggers/${id}`}>{name}</Link>
    </TableCell>
    <TableCell>
      {status === 'active' && (
        <Grid container alignItems='center'>
          <CheckCircleOutlineIcon
            style={{ color: '#4ABF51', marginRight: '5px' }}
          />
          Active
        </Grid>
      )}
    </TableCell>
    <TableCell>
      <TriggerHistory id={id} />
    </TableCell>
    <TableCell>
      <Link to={`/triggers/${id}`}>View All</Link>
    </TableCell>
    <TableCell>
      <Link to={`/triggers/${id}`}>
        <EditOutlinedIcon style={{ color: '#0070eb' }} />
      </Link>
    </TableCell>
  </AdminTableRow>
);

const Triggers = ({ beaconKey }) => {
  return (
    <Box marginTop={2}>
      <Box marginBottom={5}>
        <AdminPaginatedList
          title='Activity Triggers'
          columns={['Name', 'Status', 'Last Run', 'Run History', '']}
          url={`/admin/triggers/lookup/active/activity`}
          filter={`beaconId=${beaconKey}`}
          itemTemplate={itemTemplate}
          showCard={false}
          newAction={'/triggers/new'}
        />
      </Box>
      <Box marginBottom={5}>
        <AdminPaginatedList
          title='Profile Triggers'
          columns={['Name', 'Status', 'Last Run', 'Run History', '']}
          url={`/admin/triggers/lookup/active/profile`}
          filter={`beaconId=${beaconKey}`}
          itemTemplate={itemTemplate}
          showCard={false}
          newAction={'/triggers/new'}
        />
      </Box>
      <Box marginBottom={5}>
        <AdminPaginatedList
          title='Content Triggers'
          columns={['Name', 'Status', 'Last Run', 'Run History', '']}
          url={`/admin/triggers/lookup/active/content`}
          filter={`beaconId=${beaconKey}`}
          itemTemplate={itemTemplate}
          showCard={false}
          newAction={'/triggers/new'}
        />
      </Box>
    </Box>
  );
};

export default Triggers;
